import { useEffect } from 'react'
import { useAuth } from '../../hooks/useAuth.jsx'
import { useNotifications } from '../../hooks/useNotifications.jsx'
import { vwapRequest } from '../../lib/vwapClient.js'
import { createVwapNotificationPoller } from '../../lib/chart/vwapNotifications.js'

export default function VwapNotificationBridge() {
  const userId = useAuth()?.user?.id
  const {upsertNotification} = useNotifications()
  useEffect(() => {
    if (!userId) return
    let storage
    try {storage=window.localStorage} catch {return}
    const poller=createVwapNotificationPoller({userId,request:vwapRequest,deliver:upsertNotification,storage})
    const resume=()=> {if (!document.hidden) poller.resume()}
    poller.start()
    window.addEventListener('online',resume); window.addEventListener('pageshow',resume)
    document.addEventListener('visibilitychange',resume)
    return ()=> {
      poller.stop();window.removeEventListener('online',resume);window.removeEventListener('pageshow',resume)
      document.removeEventListener('visibilitychange',resume)
    }
  }, [userId,upsertNotification])
  return null
}
